(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row-owners-manual"] && !Shopify.designMode) return;
  try {
    // Handle ButterCMS file downloads by fetching and creating a blob download
  document.addEventListener('click', function (e) {
    const link = e.target.closest('[data-buttercms-download]');
    if (!link) return;

    e.preventDefault();

    const url = link.href;
    const filename = link.dataset.filename || 'download.pdf';

    // Show loading state
    link.style.opacity = '0.5';
    link.style.pointerEvents = 'none';

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Download failed');
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.href = blobUrl;
        tempLink.download = filename;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => {
        console.error('Download error:', error);
        // Fallback: open in new tab
        window.open(url, '_blank');
      })
      .finally(() => {
        // Reset loading state
        link.style.opacity = '';
        link.style.pointerEvents = '';
      });
  });
  } catch(e) { console.error(e); }
})();

})();
